const euPages = {
  pages: {}
}

module.exports = euPages
